<template>
  <div>
    <list
      row-key="Junior9Id"
      ref="list"
      unit="天文地理特长生初三年级"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
      :page-sizes="[10,20,50,500,1000,2000,5000]"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="报名序号">
          <el-input v-model="params.EnrollNo" placeholder="请输入报名序号" clearable />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" placeholder="请输入姓名" clearable />
        </el-form-item>
        <el-form-item label="状态" v-if="showStatus">
          <el-select v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="待提交" :value="0"></el-option>
            <el-option label="待审核" :value="1"></el-option>
            <!-- <el-option label="审核未通过" :value="2"></el-option> -->
            <!-- <el-option label="审核通过" :value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="模式选择">
          <el-select v-model="params.EnrollInfo55" placeholder="请选择" clearable>
            <el-option label="“专项测试、面试”模式" :value="false"></el-option>
            <el-option label="“64方案”模式" :value="true"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="综合素质得分" class="longLabel">
          <el-select v-model="params.QualityScore" placeholder="请选择得分" clearable>
            <el-option label="25分" :value="0"></el-option>
            <el-option label="24分" :value="1"></el-option>
            <el-option label="23分" :value="2"></el-option>
            <el-option label="≤22分" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归档状态" label-width="90px" v-if="showStatus">
          <el-select v-model="params.FileStatus" placeholder="请选择归档状态" clearable>
              <el-option label="已归档" :value="1"></el-option>
              <el-option label="未归档" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="EnrollNo" label="报名序号" />
        <el-table-column prop="FullName" label="姓名" />
        <el-table-column prop="Sex" label="性别">
          <template slot-scope="{row}">
            <span v-if="row.Sex==1">男</span>
            <span v-else>女</span>
          </template>
        </el-table-column>
        <el-table-column prop="MiddleSchool" label="毕业学校" />
        <el-table-column prop="IdCard" label="证件号" min-width="130" />
        <el-table-column prop="MiddleExamNo" label="中考报名号" />
        <el-table-column label="模式选择" width="140">
          <template slot-scope="{row}">
            <span v-if="row.EnrollInfo55">“64方案”模式</span>
            <span v-else>“专项测试、面试”模式</span>
          </template>
        </el-table-column>
        <el-table-column prop="QualityScore" label="综合素质得分">
          <template slot-scope="{row}">
            <span v-if="row.QualityScore==0">25分</span>
            <span v-else-if="row.QualityScore==1">24分</span>
            <span v-else-if="row.QualityScore==2">23分</span>
            <span v-else-if="row.QualityScore==3">≤22分</span>
          </template>
        </el-table-column>
        <el-table-column prop="Status" width="100px" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.Status==0">待提交</el-tag>
            <el-tag type="primary" v-else-if="row.Status==1">待审核</el-tag>
            <el-tag type="danger" v-else-if="row.Status==2">审核未通过</el-tag>
            <el-tag type="success" v-else-if="row.Status==3">审核通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="FileStatus" width="80px" label="归档状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="danger" v-if="row.FileStatus == 1">已归档</el-tag>
            <el-tag type="success" v-else>未归档</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    showStatus: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      api: require("@/api/po/junior9").default,
      params: {
        EnrollNo: "",
        FullName: "",
        EnrollInfo55: null,
        QualityScore: null,
        Status: null,
        EnrollInfo: true,
        Statuses: [0,1],
        FileStatus: 0,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>